import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  CustomModalProps,
  CustomerConfirm,
} from '../../../../components/ModalUser'
import {
  AllowAccountRes,
  GET_ALLOW_ACCOUNT_PAGE,
  ReconcilableParams,
} from '../../../../api/orderManage'
import { PaginationOption } from '../../../../global'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import { isResponseCodeSuccess } from '../../../../tools/util'

interface State {
  checkedKeys: string[]
  checkedData: AllowAccountRes[]
  searchParam: SearchItemFilter
  loading: boolean
  pagination: PaginationOption
  orderData: AllowAccountRes[]
}

type ActionType =
  | 'setCheckedKeys'
  | 'setCheckedData'
  | 'setSearchParam'
  | 'setLoading'
  | 'setPagination'
  | 'setOrderData'
  | 'resetState'

interface Action {
  type: ActionType
  payload?: any
}

const initialState: State = {
  checkedKeys: [],
  checkedData: [],
  searchParam: {},
  loading: false,
  pagination: {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
  },
  orderData: [],
}

const reducer = (state: State, action: Action): State => {
  const newState = { ...state }
  switch (action.type) {
    case 'setCheckedKeys':
      newState.checkedKeys = action.payload
      return newState
    case 'setCheckedData':
      newState.checkedData = action.payload
      return newState
    case 'setSearchParam':
      newState.searchParam = action.payload
      return newState
    case 'setLoading':
      newState.loading = action.payload
      return newState
    case 'setPagination':
      newState.pagination = action.payload
      return newState
    case 'setOrderData':
      newState.orderData = action.payload
      return newState
    case 'resetState':
      return initialState
    default:
      message.error('not match actions')
      throw new Error('not match actions')
  }
}

const setCheckedKeysAction = (params: string[]): Action => ({
  type: 'setCheckedKeys',
  payload: params,
})

const setCheckedDataAction = (params: AllowAccountRes[]): Action => ({
  type: 'setCheckedData',
  payload: params,
})

const setSearchParamAction = (val: SearchItemFilter): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setLoadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

const setPaginationAction = (val: PaginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

const setOrderDataAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOrderData',
  payload: val,
})

const resetStateAction = (): Action => ({
  type: 'resetState',
})

export interface Props extends Omit<CustomModalProps, 'modalSubmit'> {
  modalConfirm: (selectedRows: AllowAccountRes[]) => void
  excludeOrderIds: string[]
  originRemovedList: AllowAccountRes[]
}

const useAddOrderModalHook = (props: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedData, pagination, searchParam } = state
  const { open, excludeOrderIds, originRemovedList, modalConfirm } = props

  useEffect(() => {
    if (open) {
      handleOrderListRequest()
    } else {
      dispatch(resetStateAction())
    }
    // eslint-disable-next-line
  }, [open])

  const onChangeCheck = (selectedRowKeys: any, selectedRows: any[]) => {
    dispatch(setCheckedKeysAction(selectedRowKeys))
    dispatch(setCheckedDataAction(selectedRows))
  }

  // 删除
  const onDelete = () => {
    if (!checkedData.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
    })
  }

  // modal提交
  const modalSubmit = () => {
    modalConfirm(checkedData)
  }

  const handleOrderListRequest = async (param?: ReconcilableParams) => {
    dispatch(setLoadingAction(true))
    const res = await GET_ALLOW_ACCOUNT_PAGE({
      excludeOrderIds: excludeOrderIds.join(','),
      ...pagination,
      ...param,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      const filteredRemovedList = originRemovedList.filter(
        (item) =>
          !(param?.orderNo || param?.customer || param?.platform) ||
          item.orderNo.includes(param.orderNo!) ||
          item.customer.includes(param.customer!) ||
          item.platformCode === param?.platform,
      )
      dispatch(
        setOrderDataAction(
          filteredRemovedList.concat(
            resData.content.map((item) => ({ ...item, type: 'new' })),
          ),
        ),
      )
      dispatch(
        setPaginationAction({
          ...pagination,
          pageSize: resData.pageSize,
          pageNo: resData.pageNo,
          totalCount: resData.totalCount,
        }),
      )
    }
    dispatch(setLoadingAction(false))
  }

  const handleSearchClick = (value: SearchItemFilter) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest({
      ...value,
      pageNo: 1,
    })
  }

  const loadMoreData = () => {
    handleOrderListRequest({
      ...searchParam,
      pageSize: pagination.pageSize + 10,
    })
  }

  return {
    hooksState: state,
    onChangeCheck,
    onDelete,
    modalSubmit,
    handleSearchClick,
    loadMoreData,
  }
}

export default useAddOrderModalHook
import { message } from 'antd'
import { useEffect, useReducer } from 'react'
import {
  CustomModalProps,
  CustomerConfirm,
} from '../../../../components/ModalUser'
import {
  AllowAccountRes,
  GET_ALLOW_ACCOUNT_PAGE,
  ReconcilableParams,
} from '../../../../api/orderManage'
import { PaginationOption } from '../../../../global'
import { SearchItemFilter } from '../../../../components/SearchFilter'
import { isResponseCodeSuccess } from '../../../../tools/util'

interface State {
  checkedKeys: string[]
  checkedData: AllowAccountRes[]
  searchParam: SearchItemFilter
  loading: boolean
  pagination: PaginationOption
  orderData: AllowAccountRes[]
}

type ActionType =
  | 'setCheckedKeys'
  | 'setCheckedData'
  | 'setSearchParam'
  | 'setLoading'
  | 'setPagination'
  | 'setOrderData'
  | 'resetState'

interface Action {
  type: ActionType
  payload?: any
}

const initialState: State = {
  checkedKeys: [],
  checkedData: [],
  searchParam: {},
  loading: false,
  pagination: {
    totalCount: 0,
    pageNo: 1,
    pageSize: 10,
  },
  orderData: [],
}

const reducer = (state: State, action: Action): State => {
  const newState = { ...state }
  switch (action.type) {
    case 'setCheckedKeys':
      newState.checkedKeys = action.payload
      return newState
    case 'setCheckedData':
      newState.checkedData = action.payload
      return newState
    case 'setSearchParam':
      newState.searchParam = action.payload
      return newState
    case 'setLoading':
      newState.loading = action.payload
      return newState
    case 'setPagination':
      newState.pagination = action.payload
      return newState
    case 'setOrderData':
      newState.orderData = action.payload
      return newState
    case 'resetState':
      return initialState
    default:
      message.error('not match actions')
      throw new Error('not match actions')
  }
}

const setCheckedKeysAction = (params: string[]): Action => ({
  type: 'setCheckedKeys',
  payload: params,
})

const setCheckedDataAction = (params: AllowAccountRes[]): Action => ({
  type: 'setCheckedData',
  payload: params,
})

const setSearchParamAction = (val: SearchItemFilter): Action => ({
  type: 'setSearchParam',
  payload: val,
})

const setLoadingAction = (val: boolean): Action => ({
  type: 'setLoading',
  payload: val,
})

const setPaginationAction = (val: PaginationOption): Action => ({
  type: 'setPagination',
  payload: val,
})

const setOrderDataAction = (val: AllowAccountRes[]): Action => ({
  type: 'setOrderData',
  payload: val,
})

const resetStateAction = (): Action => ({
  type: 'resetState',
})

export interface Props extends Omit<CustomModalProps, 'modalSubmit'> {
  modalConfirm: (selectedRows: AllowAccountRes[]) => void
  excludeOrderIds: string[]
  originRemovedList: AllowAccountRes[]
}

const useAddOrderModalHook = (props: Props) => {
  const [state, dispatch] = useReducer(reducer, initialState)
  const { checkedData, pagination, searchParam } = state
  const { open, excludeOrderIds, originRemovedList, modalConfirm } = props

  useEffect(() => {
    if (open) {
      handleOrderListRequest()
    } else {
      dispatch(resetStateAction())
    }
    // eslint-disable-next-line
  }, [open])

  const onChangeCheck = (selectedRowKeys: any, selectedRows: any[]) => {
    dispatch(setCheckedKeysAction(selectedRowKeys))
    dispatch(setCheckedDataAction(selectedRows))
  }

  // 删除
  const onDelete = () => {
    if (!checkedData.length) {
      message.warning('请先选择数据')
      return
    }
    CustomerConfirm({
      title: '您正在删除对账的订单',
      content: '删除后可再次添加进来，是否删除？',
    })
  }

  // modal提交
  const modalSubmit = () => {
    modalConfirm(checkedData)
  }

  const handleOrderListRequest = async (param?: ReconcilableParams) => {
    dispatch(setLoadingAction(true))
    const res = await GET_ALLOW_ACCOUNT_PAGE({
      excludeOrderIds: excludeOrderIds.join(','),
      ...pagination,
      ...param,
    })
    if (isResponseCodeSuccess(res.code)) {
      const resData = res.data
      const filteredRemovedList = originRemovedList.filter(
        (item) =>
          !(param?.orderNo || param?.customer || param?.platform) ||
          item.orderNo.includes(param.orderNo!) ||
          item.customer.includes(param.customer!) ||
          item.platformCode === param?.platform,
      )
      dispatch(
        setOrderDataAction(
          filteredRemovedList.concat(
            resData.content.map((item) => ({ ...item, type: 'new' })),
          ),
        ),
      )
      dispatch(
        setPaginationAction({
          ...pagination,
          pageSize: resData.pageSize,
          pageNo: resData.pageNo,
          totalCount: resData.totalCount,
        }),
      )
    }
    dispatch(setLoadingAction(false))
  }

  const handleSearchClick = (value: SearchItemFilter) => {
    dispatch(setSearchParamAction(value))
    handleOrderListRequest({
      ...value,
      pageNo: 1,
    })
  }

  const loadMoreData = () => {
    handleOrderListRequest({
      ...searchParam,
      pageSize: pagination.pageSize + 10,
    })
  }

  return {
    hooksState: state,
    onChangeCheck,
    onDelete,
    modalSubmit,
    handleSearchClick,
    loadMoreData,
  }
}

export default useAddOrderModalHook
